import {example} from './example'
import { notification } from './noticefication'

export let JaTrans = {
        example,
        notification
}